import { useState } from "react";
import Slider from "react-slick";

const MunCommittees = ({ committees = [] }) => {
  const [selectedCommittee, setSelectedCommittee] = useState(null);

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="mun-committees-wrap">
      <Slider {...settings} className="mun-committees">
        {committees.map((committee, index) => (
          <div className="mun-committee-slide" key={committee.CommitteesName || index}>
            <div className="mun-committee-card">
              <h3>{committee.CommitteesName}</h3>
              <p className="mun-role">
                <strong>Chair-</strong> {committee.Chair}
              </p>
              <p className="mun-role">
                <strong>Deputy-</strong> {committee.Deputy}
              </p>
              <p>{committee.message}</p>
              <button
                type="button"
                className="mun-read-more-btn"
                onClick={() => setSelectedCommittee(committee)}
              >
                Read More
              </button>
            </div>
          </div>
        ))}
      </Slider>

      {selectedCommittee ? (
        <div
          className="mun_ncs-block mun-popup-backdrop"
          onClick={() => setSelectedCommittee(null)}
        >
          <div
            className="mun-popup-card"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="mun-popup-close"
              onClick={() => setSelectedCommittee(null)}
            >
              ×
            </button>
            <h3>{selectedCommittee.CommitteesName}</h3>
            <p className="mun-role">
              <strong>Chair-</strong> {selectedCommittee.Chair}
            </p>
            <p className="mun-role">
              <strong>Deputy-</strong> {selectedCommittee.Deputy}
            </p>
            <p>{selectedCommittee.message}</p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default MunCommittees;
